import instagramIcon from "../img/instagramIcon.png";
import linkedinIcon from "../img/linkedinIcon.png";
import githubIcon from "../img/githubIcon.png";
import whatsappIcon from "../img/whatsappIcon.png";

const data = [
    {
        id: 1,
        name: "Instagram",
        link: "https://instagram.com/fathanfdllh",
        image: instagramIcon
    },
    {
        id: 2,
        name: "Linkedin",
        link: "https://www.linkedin.com/in/fathanfadillah/",
        image: linkedinIcon
    },
    {
        id: 3,
        name: "Github",
        link: "https://github.com/fathanfadillah74",
        image: githubIcon
    },
    {
        id: 4,
        name: "Whatsapp",
        link: "https://wa.me/6281292098729",
        image: whatsappIcon
    }
]

export default data;